import { CtStorageLocation } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import ContentModule from '@/utils/store'
export const model = {
    id: {
      field: 'id',
      label: 'ID',
      validator: () => true,
      type: 'string',
      required: true
    },
    description: {
      field: 'description',
      label: 'Description',
      validator: () => true,
      type: 'string',
      required: true
    },
    // inventory_locations: {
    //   field: 'inventory_locations',
    //   label: 'Inventory Locations',
    //   validator: () => true,
    //   contentType: 'inventory_location',
    //   type: 'link-list',
    //   required: true
    // },
    sub_locations: {
      field: 'sub_locations',
      label: 'Sub-Locations',
      validator: () => true,
      contentType: 'storage_location',
      type: 'link-list',
      required: true
    }
  }
// specify actions etc. for orders using Directr
const state = {}
const getters = {}
const mutations = {}
const actions = {}

export default ContentModule<CtStorageLocation>(
  ContentType.StorageLocation, 'Services/Directr',
  model,
  state,
  getters,
  mutations,
  actions)
